import { FC } from 'react';
import htmlReactParser from 'html-react-parser';

// tempexp_PORTFOLIO-40783_next_line
import { Title, VSpacingContainer } from '@hh.ru/magritte-ui';

import AsyncHighlighter from 'src/components/Markup/AsyncHighlighter';
import { useSelector } from 'src/hooks/useSelector';

// tempexp_PORTFOLIO-40783_next_line
import VacancyBenefits from 'src/components/VacancyView/VacancyBenefits';
import VacancySectionWrapper from 'src/components/VacancyView/VacancySectionWrapper';

interface VacancyDescriptionProps {
    hasVacancySectionWrapper?: boolean;
}

const VacancyDescription: FC<VacancyDescriptionProps> = ({ hasVacancySectionWrapper = true }) => {
    const description = useSelector(({ vacancyView }) => vacancyView.description);

    // tempexp_PORTFOLIO-40783_start
    const benefits = useSelector((state) => state.vacancyBenefits);
    const hasBenefits = benefits?.length > 0;
    // tempexp_PORTFOLIO-40783_end

    const descriptionContent = (
        <div className="g-user-content" data-qa="vacancy-description">
            <AsyncHighlighter isLinkify>{htmlReactParser(description)}</AsyncHighlighter>
        </div>
    );

    const content = hasBenefits ? (
        // tempexp_PORTFOLIO-40783_start
        <VSpacingContainer default={32}>
            <VacancyBenefits />
            <VSpacingContainer default={16}>
                <Title Element="h2" size="small">
                    Описание вакансии
                </Title>
                {descriptionContent}
            </VSpacingContainer>
        </VSpacingContainer>
    ) : (
        // tempexp_PORTFOLIO-40783_end
        descriptionContent
    );

    return <VacancySectionWrapper hasWrapper={hasVacancySectionWrapper}>{content}</VacancySectionWrapper>;
};

export default VacancyDescription;
